export default import.meta.ROLLDOWN_FILE_URL_ybW9$q6e7Ao8hj2fFIQqDw